/**
 * Custom sort icon component
 */

// React
import React, { FC } from 'react';

// Images
import { arrow_down_icon } from 'assets/icons';

// Interface
interface CustomSortIconProps {
  direction?: 'asc' | 'desc';
}

// Component
const CustomSortIcon: FC<CustomSortIconProps> = ({ direction }) => {
  return (
    <img
      src={arrow_down_icon}
      style={{
        marginLeft: '5px',
        height: '10px',
        width: '10px',
        transition: 'transform 0.2s ease-in-out',
        transform: direction === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
      }}
      alt="icon rotate"
    />
  );
};

export default CustomSortIcon;
